var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconRepeatArrow = function SvgIconRepeatArrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.59 19.41 25.17 22H7v-5H5v5a2 2 0 0 0 2 2h18.17l-2.58 2.59L24 28l5-5-5-5zM25 8H6.83l2.58-2.59L8 4 3 9l5 5 1.41-1.41L6.83 10H25v5h2v-5a2 2 0 0 0-2-2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconRepeatArrow);
export { ForwardRef as ReactComponent };